const data: Record<string, unknown> = {}
const context = require.context('.', true, /^((?!index|\.unit\.).)*\.ts$/)

context.keys().forEach((file) => {
  const key = file.replace(/(\.\/|$)/g, '').split('.')[0]
  data[key] = context(file).default || context(file)
})

export default data
